import Vue from 'vue'
import App from './App.vue'


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './assets/css/index.css';
import './assets/css/animate.css';
import 'animate.css';
import i18n from './i18n';
(function (doc, win) {
  var docEl = doc.documentElement
  var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
  var recalc = function () {
    var clientWidth = docEl.clientWidth
    if (!clientWidth) return
    docEl.style.fontSize = 16 * (clientWidth / 1920) + 'px'
  }
  if (!doc.addEventListener) return
  win.addEventListener(resizeEvt, recalc, false)
  doc.addEventListener('DOMContentLoaded', recalc, false)
})(document, window)
import headerComponent from './components/headerComponent.vue';
import connectComponent from './components/connectComponent.vue';
import kfComponent from './components/kfComponent.vue';
Vue.component('header-component', headerComponent);
Vue.component('connect-component', connectComponent);
Vue.component('kf-component', kfComponent);

Vue.use(ElementUI);
Vue.config.productionTip = false


new Vue({
  i18n,
  render: h => h(App),
  mounted() {
    AOS.init({
      offset: 240,  // 距离视口 100px 时触发
      duration: 1000, // 动画持续时间
      easing: 'ease-in-out', // 动画缓动函数
    });
  },
  router,
}).$mount('#app')
